/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowReleaseLayouts } from '../../models/workflow-release-layouts';

export interface ClientGetWorkflowReleaseLayoutsGet$Params {
  release_uuid?: string;
}

export function clientGetWorkflowReleaseLayoutsGet(http: HttpClient, rootUrl: string, params?: ClientGetWorkflowReleaseLayoutsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowReleaseLayouts>>> {
  const rb = new RequestBuilder(rootUrl, clientGetWorkflowReleaseLayoutsGet.PATH, 'get');
  if (params) {
    rb.query('release_uuid', params.release_uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowReleaseLayouts>>;
    })
  );
}

clientGetWorkflowReleaseLayoutsGet.PATH = '/Client/GetWorkflowReleaseLayouts';
